import { LocaleMessages } from 'vue-i18n';
import { CompanyPreference } from './CompanyPreference';
import { GlobalConfig } from './GlobalConfig';
import { ThemeConfigResponse } from './ThemeConfigResponse';
import { UserProfileConfig } from './UserProfileConfig';
import { UserProfileSection } from './UserProfileSection';
import { SlideMenuOption } from './SlideMenuOption';
import { ProfileWizardConfig } from './ProfileWizardConfig';

export class ClientConfigs {

  public companyCode: string = "";
  public companyId: number = 0;
  //public companyLinks: any = {};
  //public companyUOM: any = {};

  public userProfileSections: UserProfileSection[] = [];
  public profileWizardConfig: ProfileWizardConfig = new ProfileWizardConfig();
  public slideMenuOptions: SlideMenuOption[] = [];
  public userProfileConfig: UserProfileConfig = new UserProfileConfig();
  public companyPreference: CompanyPreference = new CompanyPreference();
  public themeConfigResponse: ThemeConfigResponse = new ThemeConfigResponse();
  public globalConfig: GlobalConfig = new GlobalConfig();

}
